import { memo } from 'react';

import { CheckoutContributionConfirmationResponseType } from 'src/models/Checkout/Confirmation';
import { useTHelper } from 'src/utils/i18n';
import { PaymentMethod } from 'src/components/common/PaymentMethod';

type Props = {
  model: CheckoutContributionConfirmationResponseType['PaymentMethodModel'];
};

export const CheckoutConfirmationPaymentMethodSubsection = memo<Props>(({ model }) => {
  const tHelper = useTHelper('checkout.confirmation.chargedNowPaymentMethod');

  return model.CreditCardPaymentMethodTypeID ? (
    <>
      <h2 className="section-header">{tHelper('title')}</h2>
      <div className="payment-method-card">
        <PaymentMethod model={model} showManage={model.IsSavedUserPaymentMethod} />
      </div>
    </>
  ) : null;
});
